module.exports = __webpack_public_path__ + "images/kurtosis-01-desktop.png";